import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { useContatosContext } from '../../../../../contexts/ContatosContexto';
import { formatarCnpjCpfIMask } from '../../../../../helpers/formatador';
import SelectClienteEndereco from '../SelectClienteEndereco';
import { CardLine, CardSelectedCliente, RowCard } from './styles';

export default function FormSelectExpedidorRecebedor({
  label,
  clienteExpedidorRecebedor,
  setClienteExpedidorRecebedor,
  disabled,
  setAlertMessageErrors,
  tipo,
  dadosPagador,
  clienteEnderecoRemetente,
}) {
  const { removeContatoAction } = useContatosContext();

  const emailsFromRemetente = clienteEnderecoRemetente.flatMap(
    cli => cli.clienteEmails
  );

  const validateClienteEmails = async email => {
    const emailsFromPagador = [];
    dadosPagador.clienteEmails.forEach(emailPagador => {
      emailsFromPagador.push(emailPagador);
    });

    if (
      !emailsFromRemetente.includes(email) &&
      !emailsFromPagador.includes(email)
    ) {
      removeContatoAction(email);
    }
  };

  const deleteCliente = idClienteEndereco => {
    const clientes = clienteExpedidorRecebedor.filter(
      cliente => cliente.idClienteEndereco !== idClienteEndereco
    );

    if (tipo === 'Expedidor') {
      const clienteRemovido = clienteExpedidorRecebedor.filter(
        cli => cli.idClienteEndereco === idClienteEndereco
      );

      if (clienteRemovido.length > 0 && clienteRemovido[0].clienteEmails) {
        clienteRemovido[0].clienteEmails.forEach(email => {
          validateClienteEmails(email);
        });
      }
    }
    setClienteExpedidorRecebedor(clientes);
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <SelectClienteEndereco
            label={label}
            clienteOrigemDestino={clienteExpedidorRecebedor}
            setClienteOrigemDestino={setClienteExpedidorRecebedor}
            disabled={disabled}
            setAlertMessageErrors={setAlertMessageErrors}
            tipo={tipo}
          />
        </Col>
      </Row>
      <RowCard>
        <Col
          span={24}
          style={{
            visibility:
              clienteExpedidorRecebedor.length === 0 ? 'hidden' : 'visible',
          }}
        >
          {clienteExpedidorRecebedor.map(clienteEndereco => (
            <CardSelectedCliente key={clienteEndereco.idClienteEndereco}>
              <CardLine>
                <Col span={22}>
                  <p className="text-bold">
                    {`${clienteEndereco.nomeCliente} - ${formatarCnpjCpfIMask(
                      clienteEndereco.cnpj
                    )}`}
                  </p>
                  <p style={{ textTransform: 'capitalize' }}>
                    <span className="text-bold">Endereço: </span>
                    {`${clienteEndereco.endereco}  `}
                  </p>
                  <p style={{ textTransform: 'capitalize' }}>
                    <span className="text-bold">Bairro: </span>
                    {`${clienteEndereco.bairro}  `}
                  </p>
                  <p style={{ textTransform: 'capitalize' }}>
                    <span className="text-bold">CEP: </span>
                    {`${clienteEndereco.cep}  `}
                    <span className="text-bold"> Cidade/Estado: </span>
                    {`${clienteEndereco.cidade} - ${clienteEndereco.estado}`}
                  </p>
                </Col>
                <Col span={2}>
                  <Row
                    justify="center"
                    align="middle"
                    style={{ height: '100%' }}
                  >
                    <Button
                      aria-label="removeCliente"
                      type="link"
                      disabled={disabled}
                      icon={
                        <CloseOutlined
                          style={{ fontSize: '16px', color: '#8C8C8C' }}
                        />
                      }
                      onClick={() =>
                        deleteCliente(clienteEndereco.idClienteEndereco)
                      }
                    />
                  </Row>
                </Col>
              </CardLine>
            </CardSelectedCliente>
          ))}
        </Col>
      </RowCard>
    </>
  );
}

FormSelectExpedidorRecebedor.propTypes = {
  label: PropTypes.string.isRequired,
  clienteExpedidorRecebedor: PropTypes.arrayOf(PropTypes.any).isRequired,
  setClienteExpedidorRecebedor: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  setAlertMessageErrors: PropTypes.func.isRequired,
  tipo: PropTypes.string.isRequired,
  dadosPagador: PropTypes.shape({
    id: PropTypes.number,
    id_cliente_endereco: PropTypes.number,
    bairro: PropTypes.string,
    cep: PropTypes.string,
    cidade: PropTypes.string,
    cnpj: PropTypes.string,
    endereco: PropTypes.string,
    uf: PropTypes.string,
    razao_social: PropTypes.string,
    id_cidade: PropTypes.number,
    ibge_cidade: PropTypes.number,
    id_estado: PropTypes.number,
    clienteEmails: PropTypes.arrayOf(PropTypes.any),
  }),
  clienteEnderecoRemetente: PropTypes.arrayOf(PropTypes.any),
};

FormSelectExpedidorRecebedor.defaultProps = {
  disabled: false,
  dadosPagador: null,
  clienteEnderecoRemetente: [],
};
